import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const PinVerificationDialog = ({ open, onOpenChange, onSuccess, title = "Verificación Requerida" }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { verifyPassword } = useAuth();

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await verifyPassword(password);

    if (result.success) {
      setPassword('');
      onSuccess();
      onOpenChange(false);
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="pin-verification-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            Por seguridad, por favor ingresa tu contraseña para continuar.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleVerify} className="space-y-4">
          <div>
            <Label htmlFor="password">Contraseña</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="pin-password-input"
              placeholder="Ingresa tu contraseña"
              className="mt-1"
            />
            {error && <p className="text-sm text-destructive mt-1">{error}</p>}
          </div>
          <div className="flex gap-2 justify-end">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              data-testid="pin-cancel-button"
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={loading || !password}
              data-testid="pin-verify-button"
            >
              {loading ? 'Verificando...' : 'Verificar'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};